//Please add the language resource
const purchOrderWhiteList = {
  purchOrderNo:'采购订单号',
  plantCode:'基地编码',
  plantName:"基地名称",
  supplierCode:"供应商编码",
  supplierName:'供应商名称',
  sampleTimeEnd:'结束毒素检测-时间',
  whiteListExpirationTime:'执行到期日期',
  whiteListUnloadStorageCode: '卸货库位编码',
  whiteListUnloadStorageName: '卸货库位',
  qcControlFlagDesc: '质检控制环节',
  contractTotalWeight: '合同总重量',
  contractWeightUnit: '合同总重量单位',
  vehicleNo:'车牌号',
  driverName:'司机姓名',
  driverTel:'电话',
  activeOff:'是否启用',
  whiteListGoodsCategory:'货物类别',
  msg:{
  }
};
export default purchOrderWhiteList



// WEBPACK FOOTER //
// ./src/page/md/purchOrderWhiteList/lang/purchOrderWhiteList.en.js